import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getAtlantaStructuredData() {
  const url = "https://restorehair.com/locations/georgia/atlanta/";
  const description =
    "Find out about your hair transplant options in Atlanta with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("atlanta", url, description),
    locationPageCrumbs(url, "Atlanta"),
  ];
}
